<div class="wetter_content_container">
  <section class="bericht-text-container">
    <h3>Großwetterlage</h3>
    <p>{{berlinWetterbericht?.grosswetterlage?.kurzbeschreibung}}</p>
  </section>
  <app-progress-indicator [indicatorType]="'PROGRESS_SPINNER'" [inProgress]="isLoading"></app-progress-indicator>
  <section *ngIf="!isLoading" class="bericht-text-container">
    <span class="bericht-text-sub-label">Aktuelle Temperaturen</span>
    <mat-list>
      <mat-list-item style="font-size: 14px"
                     *ngFor="let bezirk of getAktuelleTemperaturenSortedByOrtsteilNameAscending()"><span
        style="width: 250px">{{bezirk.name}}:</span> <span
        style="width: 50px;margin-left: 25px">{{bezirk.wert}}</span>
        °C
      </mat-list-item>
    </mat-list>
  </section>
  <section class="bericht-text-container">
    <span class="bericht-text-sub-label">Niederschlag - Kommende sechs Stunden</span>
<!--    <span class="bericht-text-sub-label" style="font-size: 14px"></span>-->
    <p>{{berlinWetterbericht?.niederschlagswahrscheinlichkeit?.kommende_6_stunden}}</p>
  </section>
  <section class="bericht-text-container">
    <span class="bericht-text-sub-label">Vorhersage</span>
    <section>
      <span class="bericht-text-sub-label">Kommende Stunden</span>
      <p>{{berlinWetterbericht?.vorhersage_kommende_stunden?.mit_wind_und_temperatur}}</p>
    </section>
    <section>
      <span class="bericht-text-sub-label">Kommende zwei Tage</span>
      <p>{{berlinWetterbericht?.vorhersage_kommende_2_Tage?.mit_wind_und_temperatur}}</p>
    </section>
  </section>

  <!-- TODO: Punktmesswerte holen -->
</div>
